type Result =
	| {
			isValid: false;
	  }
	| {
			isValid: true;
			integerPart: number;
	  };
export function parseIntegerAmount(value: string): Result {
	// This regex validates if the input string represents a non-negative integer or a non-negative decimal number
	const isNonNegativeNumberFormat = /^\d*\.?\d*$/.test(value);

	if (isNonNegativeNumberFormat) {
		const integerPart = value.split('.')[0];
		const parsed = integerPart === '' ? 0 : Number(integerPart);
		if (parsed > Number.MAX_SAFE_INTEGER) {
			return { isValid: false };
		}
		return { integerPart: parsed, isValid: true };
	}

	// Negative numbers: invalid but still extract integer part
	if (/^-\d+$/.test(value)) {
		return { isValid: false };
	}

	return { isValid: false };
}
